var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMessengerCircle = function SvgMessengerCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#messengerCircle_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.933 2.933A9.962 9.962 0 0 1 10 0c5.524 0 10 4.476 10 10a9.962 9.962 0 0 1-2.933 7.067A9.962 9.962 0 0 1 10 20a9.962 9.962 0 0 1-7.067-2.933A9.962 9.962 0 0 1 0 10a9.962 9.962 0 0 1 2.933-7.067Zm5.39 12.353c.534.143 1.096.219 1.686.219 3.296 0 5.848-2.41 5.848-5.667 0-3.257-2.562-5.667-5.848-5.667-3.285 0-5.838 2.41-5.838 5.667 0 1.705.696 3.171 1.829 4.19.095.086.162.21.162.334L6.19 15.4a.47.47 0 0 0 .658.419l1.162-.514a.505.505 0 0 1 .314-.02Zm3.486-4.029 1.715-2.724c.162-.266-.162-.562-.4-.371l-1.848 1.4a.343.343 0 0 1-.419 0L9.486 8.533a.875.875 0 0 0-1.267.238l-1.714 2.724c-.172.257.152.553.4.372l1.847-1.4a.343.343 0 0 1 .42 0l1.361 1.019c.41.304 1 .2 1.277-.229Z",
    fill: "url(#messengerCircle_svg__b)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "messengerCircle_svg__b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(3.848 .105) scale(21.7905)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A033FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#FF5280"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7061"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "messengerCircle_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    fill: "#fff"
  })))));
};
export default SvgMessengerCircle;